<template>
    <el-dialog
            :title="editTextConfig.title"
            :visible.sync="dialogVisible"
            :append-to-body="true"
            :close-on-click-modal="false"
            @close="reset"
            width="700px">

        <el-form :model="form" :rules="rules" ref="form" label-width="120px">
            <el-form-item :label="formTextConfig.examineeIdcard" prop="examineeIdcard">
                <el-input v-model="form.examineeIdcard" :placeholder="formTextConfig.examineeIdcardTip" maxlength="18" show-word-limit clearable></el-input>
                <span>{{formTextConfig.tip}}</span>
            </el-form-item>
        </el-form>

        <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">{{ formTextConfig.button.cancel }}</el-button>
            <el-button type="primary" @click="saveExamineeHandle">{{ formTextConfig.button.ok }}</el-button>
        </span>
    </el-dialog>
</template>

<script>
    import {editExaminee} from "@/api/arrangement";

    export default {
        props: ['examId'],
        computed: {
            editTextConfig() {
                return this.$store.state.global.textConfig.backend.arrangement.examEdit.examinee.edit
            },  
            formTextConfig() {
                return this.editTextConfig.form
            },
        },
        data() {
            return {
                dialogVisible: false,
                examineeId: null,
                form: {
                    examineeName: null,
                    admissionNo: null,
                    examineeIdcard: null,
                    pilotSchool: null,
                },
                rules: {
                    examineeIdcard: [
                        {
                            validator: function (rule, value, callback) {
                                if (/^[a-zA-Z0-9]*$/.test(value) === false && value) {
                                    callback(new Error("仅支持输入大小写字母和数字"))
                                } else {
                                    callback();
                                }
                            },
                            trigger: 'blur',
                        },
                    ],

                }
            }
        },

        methods: {
            open(row) {
                this.examineeId = row.id
                this.form = {
                    examineeIdcard: row.examineeIdcard,
                }
                this.dialogVisible = true
            },
            saveExamineeHandle() {
                this.$refs.form.validate(vaild => {
                    if (vaild) {
                        editExaminee(this.examId, this.examineeId, this.form).then(res => {
                            if (res.status === 200) {
                                this.$message.success('保存成功')
                                this.dialogVisible = false
                                this.$emit('success')
                            }
                        })
                    }
                })
            },
            reset() {
                this.form = {
                    examineeIdcard: null,
                }
                this.examineeId = null
                this.$refs.form.resetFields()
            }
        }
    }
</script>

<style scoped>

</style>
